import { Controller } from "@hotwired/stimulus"

// iot--gateway-zone-picker — keeps the gateway edit page's zone multi-select
// in step with the building chosen in its Site → Building cascade.
//
// A gateway covers several zones, but only of ONE building, so the zones are
// offered one building at a time: when the building changes, the
// `gateway_zone_options` Turbo Frame is pointed at
// Iot::GatewaysController#zone_options for the new building, and the server
// renders that building's multi-select.
//
// Bound with `change->iot--gateway-zone-picker#refresh` on the picker's
// wrapper, so it hears every change that bubbles up from inside it — the
// building select, the site select, the zone checkboxes. It acts only when
// the BUILDING value differs from the one the frame shows. That covers the
// case conek-ui's ui--facilities--location-cascade creates on purpose:
// changing the site empties the building SILENTLY (no change event of its
// own), and the site's change reaches this handler after the cascade's own
// listener has already emptied it — so the frame drops to its "choose a
// building" state instead of keeping the old building's zones.
export default class extends Controller {
  static targets = ["building", "frame"]
  static values = { url: String }

  refresh() {
    if (!this.hasBuildingTarget || !this.hasFrameTarget) return

    const select = this.buildingTarget.querySelector("select")
    const buildingId = select ? select.value : ""
    if (buildingId === (this.frameTarget.dataset.buildingId || "")) return

    const url = new URL(this.urlValue, window.location.origin)
    if (buildingId) url.searchParams.set("building_id", buildingId)
    this.frameTarget.dataset.buildingId = buildingId
    // The attribute, not the `src` property: Turbo's <turbo-frame> watches the
    // attribute and loads on change, and it stays observable where Turbo has
    // not upgraded the element.
    this.frameTarget.setAttribute("src", `${url.pathname}${url.search}`)
  }
}
